import script from "./AttributeCoverage.vue?vue&type=script&setup=true&lang=js"
export * from "./AttributeCoverage.vue?vue&type=script&setup=true&lang=js"

import "./AttributeCoverage.vue?vue&type=style&index=0&id=59ff8e23&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59ff8e23"]])

export default __exports__